import React from 'react';
import { Table } from 'react-bootstrap';
import Row from "./components/Row";

const PushapiCpcAllTable = ({ report, onSortChange }) => {
    const rows = report.map((row, index) => (<Row {...row} key={index} />));

    return (
        <Table bordered responsive style={{ textAlign: 'center', verticalAlign: 'middle' }}>
            <thead>
                <tr>
                    <th onClick={() => onSortChange('country')}>Country</th>
                    <th onClick={() => onSortChange('cpc')}>Factor</th>
                </tr>
            </thead>
            <tbody>
                {rows}
            </tbody>
        </Table>
    )
};

export default PushapiCpcAllTable;


// WEBPACK FOOTER //
// ./src/scenes/PushapiCpcAll/components/Table/index.js